import { ACTIVE_SERVER_ID } from 'mk/settings';

// mappings from old /help/#hash urls

export const HELP_HASH_TARGETS = {
    201: {
        'cat-aboutus': '/faq/faq/#h-o-modrom-konikovi',
        'aboutus': '/faq/co-je-modry-konik/',
        'aboutus-people': '/faq/kto-tvori-modreho-konika/',
        'aboutus-company': '/faq/prevadzkovatel-a-fakturacne-udaje/',

        'cat-login': '/faq/faq/#h-problem-s-registraciou-prihlasenim',
        'registration-what-is-it': '/faq/co-je-registracia/',
        'registration-not-succeed': '/faq/neviem-sa-registrovat-vytvorit-si-novy-profil/',
        'registration-phone-verification': '/faq/mam-problem-s-overenim-registracie-cez-sms/',
        'no-password-login': '/faq/neviem-sa-prihlasit-zabudla-som-heslo/',
        'no-username-login': '/faq/neviem-sa-prihlasit-zabudla-som-svoj-login-prihlasovacie-meno/',
        'no-password-and-email-login': '/faq/neviem-sa-prihlasit-zabudla-som-vsetko-neviem-heslo-login-email-co-teraz/',
        'registration-phone-verification-why': '/faq/preco-je-potrebne-overenie-cez-sms/',
        'no-new-password-in-email': '/faq/snazila-som-sa-obnovit-si-heslo-cez-email-ale-ziaden-email-mi-neprisiel/',
        'unblock-me': '/faq/snazila-som-sa-prihlasit-pristup-na-profil-bol-zruseny-da-sa-obnovit/',

        'cat-howto': '/faq/faq/#h-co-kde-najdem-ako-nieco-urobim',

        'cat-howto-start': '/faq/faq-index-som-tu-nova/',
        'info-page-sections': '/faq/potrebujem-sa-zorientovat-na-modrom-koniku/',
        'info-first-name-use': '/faq/preco-mi-tykate-ina-pouzivatelka-mi-tiez-tyka/',
        'info-hearts': '/faq/prislo-mi-srdiecko-co-to-je/',
        'info-visibility-post': '/faq/kto-moze-vidiet-moje-prispevky-z-modreho-konika/',

        'cat-howto-account': '/faq/faq-index-nastavenia-mojho-profilu/',
        'info-my-profile': '/faq/co-je-moj-profil-ako-ho-najdem/',
        'change-username': '/faq/chcem-si-zmenit-login-prihlasovacie-meno/',
        'change-password': '/faq/ako-si-zmenim-heslo/',
        'change-email': '/faq/ako-si-zmenim-emailovu-adresu/',
        'change-email-used': '/faq/neviem-si-zmenit-emailovu-adresu-ukazuje-mi-ze-uz-je-pouzita-pre-iny-profil-co-teraz/',
        'change-mobile': '/faq/ako-si-zmenim-telefonne-cislo/',
        'change-mobile-used': '/faq/neviem-si-zmenit-telefonne-cislo-vraj-je-uz-pouzite-pre-iny-profil-co-teraz/',
        'change-profile-info': '/faq/ako-si-upravim-osobne-udaje-ktore-sa-zobrazuju-na-mojom-profile/',
        'info-notifications-on-email': '/faq/ako-si-nastavim-emaily-ktore-mi-chodia-z-modreho-konika/',
        'logout-me': '/faq/ako-sa-pre-dnesok-odhlasim-zo-svojho-profilu/',
        'block-me': '/faq/ako-si-zrusim-svoj-profil-na-modrom-koniku/',
        'info-block-user': '/faq/co-sa-stane-ak-si-zrusim-svoj-profil-na-modrom-koniku/',

        'cat-howto-forum': '/faq/faq-index-diskusie/',
        'forum-saved-threads': '/faq/faq-index-diskusie/',
        'change-forum-post': '/faq/chcem-upravit-svoj-prispevok-v-diskusiach/',
        'why-we-rename-forum-post': '/faq/preco-upravujeme-nazvy-diskusii/',
        'delete-post-forum': '/faq/mozem-zmazat-svoju-diskusiu-alebo-moje-odpovede-komentare-vo-fore/',
        'anonymous-post-forum': '/faq/mozem-zalozit-diskusiu-bez-zverejnenia-mojho-prihlasovacieho-mena/',
        'info-star-forum': '/faq/chcem-sledovat-svoje-oblubene-fora/',
        'report-post-forum2': '/faq/chcem-nahlasit-nevhodny-komentar-alebo-celu-diskusiu-vo-fore-urazky-vulgarizmy-reklamu-spam/',
        'forum-whatis-mod': '/faq/chcem-sa-stat-moderatorkou-fora/',

        'cat-howto-blogs': '/faq/faq-index-stena/',
        'info-write-post-blogs': '/faq/ako-pridam-prispevok-na-stenu/',
        'info-my-blog': '/faq/ako-funguju-prispevky-na-mojom-profile/',
        'change-post-blogs': '/faq/chcem-zmenit-svoju-uz-zverejnenu-kratku-spravu/',
        'delete-post-blogs': '/faq/chcem-zmazat-svoj-uz-zverejneny-prispevok-kratku-spravu-album-clanok/',
        'info-share-post-blogs': '/faq/ako-funguje-chcem-zdielat-prispevok/',
        'info-like-post-blogs': '/faq/ako-funguje-paci-sa-mi-prispevok/',
        'info-user-follow': '/faq/mozem-odoberat-novinky-od-zaujimavych-pouzivateliek/',
        'add-favorite-user': '/faq/ako-pridam-pouzivatelku-k-svojim-oblubenym/',
        'info-feed-subscriptions-blogs': '/faq/ako-funguje-zalozka-odoberam-na-stene/',
        'info-feed-popular-blogs': '/faq/ako-funguje-zalozka-popularne/',
        'blogs-all-ignored': '/faq/nechcem-uz-na-stene-vidiet-prispevky-tejto-pouzivatelky/',
        'info-user-not-active': '/faq/na-profilu-jine-uzivatelky-sviti-pod-jejim-fotoportretem-neaktivni-co-to-znamena/',

        'cat-howto-groups': '/faq/faq-index-skupiny/',
        'groups-what': '/faq/co-su-skupiny/',
        'groups-where': '/faq/kde-najdem-zoznam-vsetkych-skupin/',
        'groups-where-my': '/faq/ako-najdem-skupiny-kde-som-clenom/',
        'new-member-groups': '/faq/chcem-sa-stat-clenom-skupiny/',
        'new-group': '/faq/chcem-si-zalozit-vlastnu-skupinu-ako-na-to/',
        'group-whatis-mod': '/faq/co-obnasa-moderovanie-skupiny/',
        'new-moderator-groups': '/faq/chcem-sa-stat-moderatorkou-skupiny/',
        'add-moderator-groups': '/faq/som-moderatorka-skupiny-a-chcem-pridat-spolumoderatorku/',
        'not-moderator-groups': '/faq/uz-nechcem-byt-moderatorkou-skupiny/',

        'cat-howto-market': '/faq/faq-index-bazar/',

        'cat-howto-market-buyer': '/faq/faq-index-bazar-ako-nakupovat/',
        'info-how-to-buy': '/faq/chcem-nakupit-v-bazari-modreho-konika-ako-na-to/',
        'info-to-buy-safe': '/faq/rady-a-tipy-k-bezpecnemu-nakupu/',
        'buy-no-registration': '/faq/da-sa-nakupit-bez-registracie/',
        'give-me-contact-other-user': '/faq/poskytnite-mi-prosim-kontakt-na-ineho-pouzivatela/',
        'find-seller': '/faq/ako-najdem-vsetky-inzeraty-od-konkretneho-predajcu/',
        'info-my-shopping-market': '/faq/kde-najdu-inzeraty-o-ktere-jsem-projevia-zajem-i-ty-ktere-uz-prodejce-smazal/',
        'info-star-market': '/faq/ako-funguje-ulozene-inzeraty/',
        'seller-not-answer': '/faq/predajca-nereaguje-na-moju-spravu-co-robit/',
        'info-watchdog-market': '/faq/ako-sa-dozviem-o-novych-inzeratoch-ktore-ma-zaujimaju/',
        'delete-watchdog-market': '/faq/ako-si-zrusim-zasielanie-emailov-o-novych-inzeratoch/',
        'info-review-market': '/faq/ako-funguje-hodnotenie-v-bazari/',
        'why-review-market': '/faq/na-co-sluzia-hodnotenia-v-bazare/',
        'no-review-listing-market': '/faq/nemam-pri-inzerate-moznost-pridat-hodnotenie-predajcovi-co-s-tym/',
        'change-review-market': '/faq/chcem-zmenit-alebo-zmazat-pridane-hodnotenie/',
        'review-deleted-listing-market': '/faq/chcem-pridat-hodnotenie-k-zmazanemu-inzeratu/',
        'disagree-review-market2': '/faq/nesuhlasim-s-hodnotenim-ktore-som-dostala-od-predajcu/',
        'listing-want-to-buy-market': '/faq/kam-mozem-vlozit-inzerat-kupim/',
        'want-to-buy-from-eshop-market': '/faq/chcem-kupit-novy-tovar-so-zarukou-a-s-blockom-ako-na-to/',

        'cat-howto-market-seller': '/faq/faq-index-bazar-ako-predavat/',
        'info-general-market': '/faq/preco-inzerovat-na-modrykonik-sk-ake-su-podmienky-a-co-to-stoji/',
        'number-listing-market': '/faq/kolko-inzeratov-mozem-pridat-do-bazara/',
        'number-photo-listing-market': '/faq/kolko-fotiek-mozem-pridat-v-jednom-inzerate/',
        'info-quality-new-listing-market': '/faq/co-je-novy-tovar/',
        'info-quality-old-listing-market': '/faq/co-je-pouzity-tovar/',
        'info-quality-handmade-listing-market': '/faq/co-je-vlastna-vyroba/',
        'info-time-listing-market': '/faq/ako-dlho-sa-bude-moj-inzerat-zobrazovat/',
        'info-update-listing-market': '/faq/ako-funguje-aktualizacia-inzeratov/',
        'unseen-listing-market': '/faq/pridala-som-inzerat-ale-neobjavil-sa-v-bazari/',
        'change-listing-market': '/faq/chcem-zmenit-uz-zadany-inzerat/',
        'how-to-answer-buyer-listing-market': '/faq/kde-najdem-spravy-od-zaujemcov-a-ako-im-odpoviem/',
        'notification-message-from-buyer-listing-market': '/faq/upozornite-ma-na-novu-spravu-od-zaujemcu/',
        'add-annoucement-market': '/faq/ako-pridam-oznam-do-bazara-napr-o-dlhsej-dovolenke-chorobe-o-akcii-a-pod/',
        'info-review-market2': '/faq/ako-funguje-hodnotenie-v-bazari/',
        'disagree-review-market': '/faq/nesuhlasim-s-hodnotenim-ktore-som-dostala-od-kupujuceho/',
        'info-delete-listing-market': '/faq/ako-najdem-zmazane-inzeraty/',
        'undelete-listing-market': '/faq/chcem-obnovit-zmazany-inzerat/',
        'expired-listing-market': '/faq/co-znamena-inzerat-je-exspirovany/',
        'over-limit-listing-market': '/faq/co-znamena-inzerat-je-nad-limit/',
        'photo-used-listing-market': '/faq/ake-su-pravidla-pre-fotky-v-inzeratoch-s-pouzitym-tovarom/',
        'own-photo-used-listing-market': '/faq/preco-musim-v-inzerate-s-pouzitym-tovarom-mat-vlastne-fotografie/',
        'xml-export-import-market': '/faq/je-mozny-export-a-import-dat-xml-z-nasho-e-shopu/',
        'unblock-my-bazar': '/faq/chcem-poziadat-o-odblokovanie-mojho-bazara/',
        'number-listing-quality-new-market': '/faq/kolko-inzeratov-noveho-tovaru-mozem-pridat-do-bazara/',

        'how-sell-more-than-10-quality-new-market': '/faq/mam-na-predaj-viac-ako-20-novych-veci-co-mozem-robit/',
        'why-my-listing-in-quality-new-market': '/faq/nemam-e-shop-ani-obchod-preco-mi-preradujete-inzeraty-do-novy-tovar/',

        'cat-paid': '/faq/faq/#h-platene-baliky-plus-pro',
        'cat-buysell-problem': '/faq/faq/#h-mam-problem-s-predajcom-kupujucim',
        'cat-howto-market-other': '/faq/faq-index-bazar-ine/',
        'report-new-brand-market': '/faq/chcem-nahlasit-chybajucu-znacku-do-bazara/',

        'cat-howto-wiki': '/faq/faq-index-odborne-clanky/',
        'wiki-suggestion': '/faq/mam-navrh-na-doplnenie-opravenie-informacie-v-odbornom-clanku-na-modrom-koniku/',

        'cat-howto-ip': '/faq/faq-index-interna-posta/',
        'what-is-ip': '/faq/co-je-interna-posta-ip/',
        'find-ip': '/faq/ako-najdem-svoju-internu-postu/',
        'info-get-new-ip': '/faq/ako-zistim-ze-mi-niekto-napisal-novu-internu-postu/',
        'send-new-ip': '/faq/ako-napisem-internu-postu-inej-pouzivatelke/',
        'image-ip': '/faq/chcem-poslat-v-internej-poste-obrazok-alebo-foto/',
        'was-read-ip': '/faq/ako-zistim-ci-prijemca-moju-spravu-precital/',
        'info-star-ip': '/faq/ako-funguje-ulozene-spravy/',
        'mail-cancel-emails': '/faq/ne-chcem-aby-mi-upozornenia-o-novej-sprave-chodili-na-email/',

        'report-listing-market': '/faq/faq/#h-chcem-nahlasit-nevhodny-prispevok-alebo-spravanie',
        'what-is-inapproptiate': '/faq/chci-nahlasit-nevhodny-komentar-nebo-celou-diskuzi-ve-foru-urazky-vulgarismy-reklamu-spam/',
        'inapproptiate-whats-next': '/faq/co-mozem-ocakavat-ked-nieco-nahlasim/',
        'report-copyright-market': '/faq/niekto-iny-v-bazari-pouziva-moje-fotky-alebo-moj-text/',

        'report-market-fraud': '/faq/mam-podozrenie-na-podvod-v-bazari/',
        'report-market-fake': '/faq/co-robit-ak-niekto-predava-nelegalne-kopie-tovaru/',

        'report-post-forum': '/faq/chcem-nahlasit-nevhodny-komentar-alebo-celu-diskusiu-vo-fore-urazky-vulgarizmy-reklamu-spam/',
        'report-message-blogs': '/faq/chcem-nahlasit-nevhodnu-spravu-clanok-ci-album-na-stene-alebo-v-profile-ineho-pouzivatela/',
        'report-comment-blogs': '/faq/chcem-nahlasit-nevhodny-komentar-pod-prispevkom-urazky-vulgarizmy-reklamu-spam/',
        'report-post-groups': '/faq/faq-index-nevhodny-prispevok-v-skupine/',
        'report-moderator-groups': '/faq/moderatorka-skupiny-nedodrziava-pravidla-modreho-konika/',
        'report-group': '/faq/chcem-nahlasit-skupinu-pretoze-porusuje-pravidla-stranky/',
        'report-spam-ip': '/faq/chcem-nahlasit-nevyziadanu-postu-obtazovanie-reklamu/',
        'report-misbehaving': '/faq/ina-pouzivatelka-obtazuje-inych-vyryva-vyvolava-konflikty/',
        'report-profile-photo': '/faq/profilova-foto-inej-pouzivatelky-porusuje-pravidla-konika-autorske-prava-je-vulgarna/',
        'report-fake-user': '/faq/chcem-nahlasit-falosnu-identitu-pouzivatelka-sa-vydava-za-niekoho-ineho/',
        'report-dupla-user': '/faq/chcem-nahlasit-pouzivatelku-ktora-pouziva-viacnasobne-ucty/',

        'cat-blocking': '/faq/faq/#h-preco-mi-bolo-nieco-odstranene-zablokovane',
        'blocking-what-to-do': '/faq/co-mam-robit-ked-mi-bolo-nieco-odstranene-zablokovane/',
        'why-delete-listing-market': '/faq/preco-bol-vymazany-moj-inzerat/',
        'blocking-changed-listing-market': '/faq/preco-ste-mi-upravili-moj-inzerat/',
        'why-block-bazaar': '/faq/preco-mi-bol-zablokovany-moj-bazar/',
        'why-block-post-blogs': '/faq/preco-bola-pozastavena-moja-kratka-sprava-album-alebo-clanok/',
        'why-block-post-groups': '/faq/preco-bol-zmazany-moj-prispevok-v-skupine/',
        'why-block-profile-photo': '/faq/preco-bola-pozastavena-alebo-nebola-schvalena-moja-profilova-fotka/',
        'why-block-user': '/faq/preco-mam-zruseny-profil/',
        'why-duplicate-logins': '/faq/preco-nemozem-mat-viac-uctov/',
        'blocking-disagree': '/faq/nesuhlasim-s-tym-co-tu-robite-citim-nespravodlivost/',

        'cat-howto-market-cheat-buyer': '/faq/faq-index-som-kupujuca-v-bazari/',
        'cheat-buyer-nogoods-regular-shipment': '/faq/neprisiel-mi-tovar-vyuzila-som-obycajne-postovne/',
        'cheat-buyer-nogoods-registered-shipment': '/faq/neprisiel-mi-tovar-vyuzila-som-doporucene-postovne/',
        'cheat-buyer-seller-not-communicating': '/faq/zaplatila-som-tovar-predajca-prestal-komunikovat/',
        'cheat-buyer-goods-not-as-described': '/faq/tovar-nezodpoveda-popisu-alebo-je-poskodeny/',
        'cheat-buyer-not-all-goods': '/faq/neprisiel-mi-vsetok-zaplateny-tovar/',

        'cat-howto-market-cheat-seller': '/faq/faq-index-som-predajca-v-bazari/',
        'cheat-seller-nogoods': '/faq/kupujuca-tvrdi-ze-jej-zaplateny-tovar-neprisiel/',
        'cheat-seller-goods-not-paid': '/faq/tovar-som-odoslala-ale-kupujuca-zan-nezaplatila/',
        'cheat-seller-cash-on-delivery-not-paid': '/faq/kupujuca-neprebrala-tovar-na-dobierku/',
        'cheat-seller-goods-not-as-described': '/faq/kupujuca-tvrdi-ze-tovar-nezodpoveda-popisu-v-inzerate/',

        'cat-howto-market-cheat-elsewhere': '/faq/faq-index-problemovy-obchod-mimo-bazara/',
        'cheat-group': '/faq/obchod-v-skupine-neprebehol-v-poriadku/',
        'cheat-ip': '/faq/komunikovali-sme-internou-postou-emailom-telefonicky-obchod-neprebehol-v-poriadku/',

        'cat-howto-market-cheat-change': '/faq/faq-index-problemova-vymena/',
        'cheat-change': '/faq/urobila-som-vymenu-tovaru-s-inou-pouzivatelkou-vymena-neprebehla-v-poriadku/',

        'cat-howto-market-cheat-legal': '/faq/faq-index-pravna-pomoc-pre-poskodenych/',
        'cheat-legal-overview': '/faq/rozhodla-som-sa-ze-podam-oznamenie-na-policii-ako-postupovat/',
        'cheat-legal-before': '/faq/co-vsetko-mozem-urobit-sama-este-pred-nahlasenim-na-policii/',
        'cheat-legal-when': '/faq/v-akom-pripade-mam-podat-oznamenie-na-policii/',
        'cheat-legal-file': '/faq/ako-mam-podat-oznamenie-na-policii/',
        'cheat-legal-prepare': '/faq/ake-doklady-mam-vziat-so-sebou-na-policiu/',
        'cheat-legal-next': '/faq/ako-zistim-co-sa-stalo-s-mojim-oznamenim/',
        'cheat-legal-joinus': '/faq/je-nas-viac-poskodenych/',
        'cheat-legal-moneyback': '/faq/dostanem-svoje-peniaze-spat/',

        'paid-choose-plus-pro': '/faq/co-je-balik-plus-a-pro-ktory-si-kupit/',
        'howto-pay-plus-or-pro': '/faq/ako-zaplatim-za-balik-plus-alebo-pro/',
        'paid-plus-pro-not-active': '/faq/zaplatila-som-za-balik-plus-alebo-pro-preco-ho-nemam-aktivny/',
        'paid-invoice-issue': '/faq/vystavite-mi-fakturu/',
        'info-paid-my-invoices': '/faq/kde-najdem-svoje-faktury/',
        'paid-change-invoicing-details': '/faq/chcem-zadat-alebo-zmenit-svoje-fakturacne-udaje/',
        'paid-invoice-problem': '/faq/mam-problem-s-fakturou-co-mam-robit/',
        'paid-regular-info': '/faq/co-v-cenniku-znamena-opakovana-platba/',
        'paid-card-error-first': '/faq/zadavam-platbu-kartou-ale-neuspesne-co-mam-robit/',
        'paid-card-sms-cancel': '/faq/ako-zrusim-automaticke-predlzovanie-predplatneho-z-karty-alebo-sms/',
        'paid-card-new': '/faq/starej-platobnej-karte-skoncila-platnost-ako-zadam-platbu-z-novej/',
        'paid-card-error-regular': '/faq/mam-nastavene-automaticke-predlzovanie-z-karty-platba-ale-neprebehla-co-mam-robit/',
        'howto-terminate-plus-pro': '/faq/chcem-ukoncit-predplatne-plus-alebo-pro-co-mam-urobit/',
        'share-reviews': '/faq/chcem-zdielat-hodnotenia-z-bazara-na-svojej-webovej-stranke/',
        'change-plus-to-pro': '/faq/chcem-prejst-z-balika-plus-na-pro-ako-na-to/',
        'gdpr-commercial': '/faq/mam-firmu-ake-su-moje-povinnosti-tykajuce-sa-gdpr/',
        'pluspro-msg': '/faq/mam-inu-otazku-suvisiacu-s-platenym-balikom-plus-alebo-pro/',

        'cat-technical-support': '/faq/faq/#h-mam-technicky-problem',
        'technical-problem-general': '/faq/modry-konik-nefunguje-tak-ako-by-mal-co-robit/',
        'technical-problem-process': '/faq/co-mozem-ocakavat-ked-problem-nahlasim/',
        'howto-screenshot': '/faq/ako-spravim-foto-obrazovky-screenshot/',
        'howto-browser-update': '/faq/ako-aktualizovat-internetovy-prehliadac/',
        'technical-problem-app': '/faq/mam-problem-s-aplikaciou-modry-konik-na-mobile/',
        'howto-clear-cache': '/faq/ako-vycistim-vyrovnavaciu-pamat-cache-prehliadaca/',

        'cat-life-situation': '/faq/faq/#h-riesim-narocnu-zivotnu-situaciu',

        'cat-life-situation-me': '/faq/faq-index-potrebujem-pomoc-v-nudzi/',
        'life-lawyer': '/faq/rozvadzam-sa-alebo-potrebujem-pravnu-poradnu-som-samozivitelka-a-mam-problem-s-financiami/',
        'life-finance': '/faq/som-vo-financnej-tiesni-hmotnej-nudzi-mam-dlhy/',
        'life-domestic-violence': '/faq/som-obetou-domaceho-nasilia-alebo-znasilnenia/',
        'life-child-illness': '/faq/ochorelo-mi-dieta-a-nemozem-si-dovolit-zaplatit-mu-liecbu-ci-potrebne-liecebne-pomocky/',
        'life-new-work': '/faq/hladam-novu-pracu/',
        'had-unplanned-pregnancy': '/faq/neplanovane-som-otehotnela/',

        'cat-life-situation-others': '/faq/faq-index-chcem-pomoct/',
        'life-giveaway-toys': '/faq/venujem-detske-oblecenie-hracky-alebo-ine-veci/',
        'life-giveaway-finance': '/faq/chcem-financne-vypomoct/',
        'life-giveaway-education': '/faq/rada-by-som-poskytla-odborne-poradenstvo/',
        'cat-life-situation-organization': '/faq/sme-organizacia-ktora-chce-pomahat-ostatnym/',

        'cat-offers': '/faq/faq/#h-navrh-na-spolupracu-ponuka-reklama',
        'offer-lowbudget-promo': '/faq/sme-mala-firma-a-radi-by-sme-u-vas-propagovali-nasu-ponuku-najradsej-zadarmo/',
        'offer-3rdsector': '/faq/sme-organizacia-tretieho-sektora-a-radi-by-sme-vas-poziadali-o-podporu-spravnej-veci/',
        'offer-press': '/faq/som-novinar-researcher-a-rad-by-som-nacrel-do-modreho-konika/',
        'offer-client': '/faq/sme-vacsi-klient-agentura-a-este-nie-sme-v-kontakte/',
        'offer-other': '/faq/chceli-by-sme-podporit-nas-projekt-akciu-medialne-partnersvo-ponuknut-nase-sluzby/',

        'cat-message-mk': '/faq/faq/#h-mam-odkaz-pre-modreho-konika',
        'message-mk': '/faq/ahoj-vita-ta-odkazovac-modreho-konika/',

        'cat-rules': '/faq/faq/#h-podmienky-pouzivania-a-pravidla',
        'privacy': '/faq/mam-otazku-ohladne-ochrany-mojich-osobnych-udajov/',
        'disagree-rules': '/faq/co-ak-nesuhlasim-s-pravidlami-modreho-konika/',
    },
    202: {
        'cat-aboutus': '/faq/faq/#h-o-modrem-koniku',
        'aboutus': '/faq/co-je-modry-konik/',
        'aboutus-people': '/faq/kdo-tvori-modreho-konika/',
        'aboutus-company': '/faq/provozovatel-fakturacni-udaje-adresa/',

        'cat-login': '/faq/faq/#h-mam-problem-s-registraci-prihlasenim',
        'registration-what-is-it': '/faq/co-je-registrace/',
        'registration-not-succeed': '/faq/nemuzu-se-zaregistrovat-vytvorit-si-novy-profil/',
        'registration-phone-verification': '/faq/mam-problem-s-overenim-registrace-pres-sms/',
        'no-password-login': '/faq/nemuzu-se-prihlasit-zapomnela-jsem-heslo/',
        'no-username-login': '/faq/nemuzu-se-prihlasit-zapomnela-jsem-svul-login-prihlasovaci-jmeno/',
        'no-password-and-email-login': '/faq/nemuzu-se-prihlasit-zapomnela-jsem-vsechno-nepamatuji-si-heslo-login-ani-emal-tak-co-ted/',
        'registration-phone-verification-why': '/faq/proc-je-overeni-pres-sms-tolik-potrebne/',
        'no-new-password-in-email': '/faq/snazila-jsem-se-obnovit-si-heslo-pres-email-ale-zadny-email-mi-neprisel/',
        'unblock-me': '/faq/snazila-jsem-se-prihlasit-ale-pristup-na-profil-byl-zrusen-da-se-obnovit/',

        'cat-howto': '/faq/faq/#h-co-kde-najdu-jak-co-udelam',
        'cat-howto-start': '/faq/faq-index-jsem-tady-nova/',
        'info-page-sections': '/faq/potrebuji-se-na-modrem-koniku-zorientovat/',
        'info-first-name-use': '/faq/proc-mi-tykate-i-dalsi-uzivatelky-mi-tady-tykaji/',
        'info-hearts': '/faq/prislo-mi-srdicko-co-to-je/',
        'info-visibility-post': '/faq/kdo-muze-videt-me-prispevky-na-modrem-koniku/',

        'cat-howto-account': '/faq/faq-index-nastaveni-meho-profilu/',
        'info-my-profile': '/faq/co-je-muj-profil-kde-ho-najdu/',
        'change-username': '/faq/chci-si-zmenit-login-prihlasovaci-jmeno/',
        'change-password': '/faq/jak-si-zmenim-heslo/',
        'change-email': '/faq/jak-si-zmenim-emailovou-adresu/',
        'change-email-used': '/faq/nejde-mi-zmenit-si-emailovou-adresu-stale-mi-to-hlasi-ze-email-je-uz-pouzity-u-jineho-profilu-co-ted/',
        'change-mobile': '/faq/jak-si-mohu-zmenit-telefonni-cislo/',
        'change-mobile-used': '/faq/nejde-mi-zmenit-si-telefonni-cislo-ze-pry-je-uz-pouzito-u-jineho-profilu-co-ted/',
        'change-profile-info': '/faq/jak-si-upravim-sve-osobni-udaje-ktere-se-zobrazuji-na-mem-profilu/',
        'info-notifications-on-email': '/faq/jak-si-nastavim-emaily-ktere-mi-z-modreho-konika-chodi/',
        'logout-me': '/faq/jak-se-pro-dnesek-odhlasim-ze-sveho-profilu/',
        'block-me': '/faq/jak-si-zrusim-svuj-profil-na-modrem-koniku/',
        'info-block-user': '/faq/co-se-stane-kdyz-si-zrusim-profil-na-modrem-koniku/',

        'cat-howto-forum': '/faq/faq-index-diskuze/',
        'forum-saved-threads': '/faq/faq-index-diskuze/',
        'change-forum-post': '/faq/chci-upravit-svuj-prispevek-v-diskuzich/',
        'why-we-rename-forum-post': '/faq/proc-upravujeme-nazvy-diskuzi/',
        'delete-post-forum': '/faq/mohu-smazat-svou-diskuzi-nebo-sve-odpovedi-komentare-ve-foru/',
        'anonymous-post-forum': '/faq/muzu-zalozit-diskuzi-bez-zverejneni-sveho-prihlasovaciho-jmena/',
        'info-star-forum': '/faq/chci-sledovat-svoje-oblibene-diskuze/',
        'report-post-forum2': '/faq/chcem-nahlasit-nevhodny-komentar-alebo-celu-diskusiu-vo-fore-urazky-vulgarizmy-reklamu-spam/',
        'forum-whatis-mod': '/faq/chci-se-stat-moderatorkou-fora/',

        'cat-howto-blogs': '/faq/faq-index-zed/',
        'info-write-post-blogs': '/faq/jak-pridam-prispevek-na-zed/',
        'info-my-blog': '/faq/jak-funguji-prispevky-na-mem-profilu/',
        'change-post-blogs': '/faq/chci-zmenit-svou-uz-zverejnenou-kratkou-zpravu/',
        'delete-post-blogs': '/faq/chci-smazat-svuj-uz-zverejneny-prispevek-kratkou-zpravu-album-clanek/',
        'info-share-post-blogs': '/faq/jak-funguje-chci-sdilet-prispevek/',
        'info-like-post-blogs': '/faq/jak-funguje-libi-se-mi-prispevek/',
        'info-user-follow': '/faq/mohu-odebirat-novinky-od-zajimavych-uzivatelek/',
        'add-favorite-user': '/faq/jak-si-mohu-pridat-uzivatelku-do-svych-oblibenych/',
        'info-feed-subscriptions-blogs': '/faq/jak-funguje-zalozka-odebiram-na-zdi/',
        'info-feed-popular-blogs': '/faq/jak-funguje-zalozka-popularni/',
        'blogs-all-ignored': '/faq/nechci-uz-na-zdi-videt-prispevky-teto-uzivatelky/',
        'info-user-not-active': '/faq/na-profilu-jine-uzivatelky-sviti-pod-jejim-fotoportretem-neaktivni-co-to-znamena/',

        'cat-howto-groups': '/faq/faq-index-skupiny/',
        'groups-what': '/faq/co-jsou-skupiny/',
        'groups-where': '/faq/kde-mohu-najit-seznam-vsech-skupin/',
        'groups-where-my': '/faq/jak-najdu-skupinu-ve-ktere-jsem-clenem/',
        'new-member-groups': '/faq/chci-se-stat-clenem-skupiny/',
        'new-group': '/faq/chci-si-zalozit-vlastni-skupinu-jak-na-to/',
        'group-whatis-mod': '/faq/co-obnasi-moderovani-skupiny/',
        'new-moderator-groups': '/faq/chci-se-stat-moderatorkou-skupiny/',
        'add-moderator-groups': '/faq/jsem-moderatorkou-skupiny-a-rada-bych-pridala-dalsi-spolumoderatorku/',
        'not-moderator-groups': '/faq/uz-nechci-byt-dale-moderatorkou-skupiny/',

        'cat-howto-market': '/faq/faq-index-bazar/',

        'cat-howto-market-buyer': '/faq/faq-index-bazar-jak-nakupovat/',
        'info-how-to-buy': '/faq/chci-nakoupit-v-bazaru-modreho-konika-jak-na-to/',
        'info-to-buy-safe': '/faq/rady-a-tipy-k-bezpecnemu-nakupu/',
        'buy-no-registration': '/faq/je-mozne-nakoupit-bez-registrace/',
        'give-me-contact-other-user': '/faq/poskytnete-mi-kontakt-na-jineho-uzivatele/',
        'find-seller': '/faq/jak-mohu-najit-vsechny-inzeraty-od-konkretniho-prodejce/',
        'info-my-shopping-market': '/faq/kde-najdu-inzeraty-o-ktere-jsem-projevia-zajem-i-ty-ktere-uz-prodejce-smazal/',
        'info-star-market': '/faq/jak-funguje-ulozene-inzeraty/',
        'seller-not-answer': '/faq/prodejce-nereaguje-na-mou-zpravu-co-mam-delat/',
        'info-watchdog-market': '/faq/jak-se-dozvim-o-novych-inzeratech-ktere-me-zajimaji/',
        'delete-watchdog-market': '/faq/jak-si-zrusim-posilani-emailu-o-novych-inzeratech/',
        'info-review-market': '/faq/jak-v-bazaru-funguji-hodnoceni/',
        'why-review-market': '/faq/k-cemu-slouzi-hodnoceni-v-bazaru/',
        'no-review-listing-market': '/faq/u-inzeratu-nemam-moznost-pridat-hodnoceni-prodejci-co-s-tim/',
        'change-review-market': '/faq/chci-zmenit-a-nebo-uplne-smazat-pridane-hodnoceni/',
        'review-deleted-listing-market': '/faq/chci-pridat-hodnoceni-ke-smazanemu-inzeratu/',
        'disagree-review-market2': '/faq/nesouhlasim-s-hodnocenim-ktere-mi-udelil-prodavajici/',
        'listing-want-to-buy-market': '/faq/kam-mohu-vlozit-inzerat-koupim/',
        'want-to-buy-from-eshop-market': '/faq/chci-koupit-nove-zbozi-se-zarukou-a-s-uctenkou-jak-na-to/',

        'cat-howto-market-seller': '/faq/faq-index-bazar-jak-prodavat/',
        'info-general-market': '/faq/proc-inzerovat-na-modrykonik-cz-jake-jsou-podminky-a-kolik-to-stoji/',
        'number-listing-market': '/faq/kolik-inzeratu-mohu-pridat-do-bazaru/',
        'number-photo-listing-market': '/faq/kolik-fotek-mohu-pridat-v-jednom-inzeratu/',
        'info-quality-new-listing-market': '/faq/co-je-nove-zbozi/',
        'info-quality-old-listing-market': '/faq/co-je-pouzite-zbozi/',
        'info-quality-handmade-listing-market': '/faq/co-je-vlastni-vyroba/',
        'info-time-listing-market': '/faq/jak-dlouho-se-bude-muj-inzerat-zobrazovat/',
        'info-update-listing-market': '/faq/jak-funguje-aktualizace-inzeratu/',
        'unseen-listing-market': '/faq/pridala-jsem-inzerat-ale-v-bazaru-se-neobjevil/',
        'change-listing-market': '/faq/chci-zmenit-uz-zadany-inzerat/',
        'how-to-answer-buyer-listing-market': '/faq/kde-najdu-zpravy-od-zajemce-a-jak-mu-mohu-odpovedet/',
        'notification-message-from-buyer-listing-market': '/faq/upozornite-me-na-novou-zpravu-od-zajemce/',
        'add-annoucement-market': '/faq/jak-mohu-do-sveho-bazaru-pridat-oznameni-napr-o-delsi-dovolene-nemoci-o-akci-apod/',
        'info-review-market2': '/faq/jak-v-bazaru-funguji-hodnoceni/',
        'disagree-review-market': '/faq/nesouhlasim-s-hodnocenim-ktere-jsem-dostala-od-kupujiciho/',
        'info-delete-listing-market': '/faq/jak-najdu-smazane-inzeraty/',
        'undelete-listing-market': '/faq/chci-obnovit-smazany-inzerat/',
        'expired-listing-market': '/faq/co-to-znamena-kdyz-je-inzerat-prosly/',
        'over-limit-listing-market': '/faq/co-to-znamena-kdyz-je-inzerat-nad-limit/',
        'photo-used-listing-market': '/faq/jaka-jsou-pravidla-pro-fotky-v-bazaru-na-inzeraty-s-pouzitym-zbozim/',
        'own-photo-used-listing-market': '/faq/proc-musim-mit-v-bazaru-s-pouzitym-zbozim-sve-vlastni-fotografie/',
        'xml-export-import-market': '/faq/je-mozny-export-nebo-import-dat-xml-z-naseho-e-shopu/',
        'unblock-my-bazar': '/faq/chci-pozadat-o-odblokovani-sveho-bazaru/',
        'number-listing-quality-new-market': '/faq/kolik-inzeratu-noveho-zbozi-mohu-do-bazaru-pridat/',

        'how-sell-more-than-10-quality-new-market': '/faq/mam-na-prodej-vice-nez-20-novych-veci-co-mohu-delat/',
        'why-my-listing-in-quality-new-market': '/faq/nemam-e-shop-ani-obchod-proc-mi-prerazujete-inzeraty-do-noveho-zbozi/',

        'cat-paid': '/faq/faq/#h-placene-baliky-plus-pro',
        'cat-buysell-problem': '/faq/faq/#h-mam-problem-s-prodejcem-kupujicim',
        'cat-howto-market-other': '/faq/faq-index-bazar-jine/',
        'report-new-brand-market': '/faq/chci-nahlasit-chybejici-znacku-v-bazaru/',

        'cat-howto-wiki': '/faq/faq-index-odborne-clanky/',
        'wiki-suggestion': '/faq/mam-navrh-na-doplneni-nebo-opravu-informace-ve-wiki-modry-konik/',

        'cat-howto-ip': '/faq/faq-index-interni-posta/',
        'what-is-ip': '/faq/co-je-interni-posta-ip/',
        'find-ip': '/faq/jak-mohu-najit-svou-interni-postu/',
        'info-get-new-ip': '/faq/jak-mohu-zjistit-jestli-mi-nekdo-poslal-novou-interni-postu/',
        'send-new-ip': '/faq/jak-mohu-napsat-interni-postu-jine-uzivatelce/',
        'image-ip': '/faq/chci-poslat-v-interni-poste-obrazek-nebo-fotku/',
        'was-read-ip': '/faq/jak-zjistim-ze-prijemce-mou-zpravu-precetl/',
        'info-star-ip': '/faq/jak-funguji-ulozene-zpravy/',
        'mail-cancel-emails': '/faq/ne-chci-aby-mi-upozorneni-o-nove-interni-poste-chodila-na-email/',

        'report-listing-market': '/faq/faq/#h-chci-nahlasit-nevhodny-prispevek-nebo-chovani',
        'what-is-inapproptiate': '/faq/co-je-nevhodny-prispevek-a-nevhodne-chovani/',
        'inapproptiate-whats-next': '/faq/co-muzu-ocekavat-kdyz-neco-nahlasim/',
        'report-copyright-market': '/faq/nekdo-jiny-v-bazaru-pouziva-moje-fotky-nebo-muj-text/',

        'report-market-fraud': '/faq/mam-podezreni-na-podvod-v-bazaru/',
        'report-market-fake': '/faq/co-delat-kdyz-nekdo-prodava-nelegalni-kopie-zbozi-padelky/',

        'report-post-forum': '/faq/chci-nahlasit-nevhodny-komentar-nebo-celou-diskuzi-ve-foru-urazky-vulgarismy-reklamu-spam/',
        'report-message-blogs': '/faq/chci-nahlasit-nevhodnou-zpravu-clanek-nebo-album-na-zdi-nebo-na-profilu-jineho-uzivatele/',
        'report-comment-blogs': '/faq/chci-nahlasit-nevhodny-komentar-pod-prispevkem-urazky-vulgarismy-reklamu-spam/',
        'report-post-groups': '/faq/chci-nahlasit-nevhodny-prispevek-urazky-vulgarizmy-reklamu-spam-ve-skupine/',
        'report-moderator-groups': '/faq/moderatorka-skupiny-nedodrzuje-pravidla-modreho-konika/',
        'report-group': '/faq/chci-nahlasit-skupinu-protoze-porusuje-pravidla-stranky/',
        'report-spam-ip': '/faq/chci-nahlasit-nevyzadanou-postu-obtezovani-reklamu/',
        'report-misbehaving': '/faq/jina-uzivatelka-obtezuje-ostatni-provokuje-vyvolava-konflikty/',
        'report-profile-photo': '/faq/profilova-fotka-jine-uzivatelky-porusuje-pravidla-modreho-konika-autorska-prava-nebo-je-vulgarni/',
        'report-fake-user': '/faq/chci-nahlasit-falesnou-identitu-uzivatelka-se-vydava-za-nekoho-jineho/',
        'report-dupla-user': '/faq/chci-nahlasit-uzivatelku-ktera-pouziva-vice-uctu/',

        'cat-blocking': '/faq/faq/#h-proc-mi-bylo-neco-zablokovane-odstranene',
        'blocking-what-to-do': '/faq/co-mam-delat-kdyz-mi-bylo-neco-odstranene-nebo-zablokovane/',
        'why-delete-listing-market': '/faq/proc-byl-vymazany-muj-inzerat/',
        'blocking-changed-listing-market': '/faq/proc-mi-byl-upraveny-muj-inzerat/',
        'why-block-bazaar': '/faq/proc-mi-byl-zablokovany-muj-bazar/',
        'why-block-post-blogs': '/faq/proc-byla-pozastavena-moje-kratka-zprava-album-nebo-clanek/',
        'why-block-post-groups': '/faq/proc-byl-smazany-muj-prispevek-ve-skupine/',
        'why-block-profile-photo': '/faq/proc-byla-pozastavena-nebo-nebyla-schvalena-moje-profilova-fotka/',
        'why-block-user': '/faq/proc-mam-zruseny-profil/',
        'why-duplicate-logins': '/faq/proc-nemohu-mit-vice-uctu/',
        'blocking-disagree': '/faq/nesouhlasim-s-tim-co-tu-delate-citim-nespravedlnost/',

        'cat-howto-market-cheat-buyer': '/faq/faq-index-jsem-kupujici-v-bazaru/',
        'cheat-buyer-nogoods-regular-shipment': '/faq/zbozi-mi-neprislo-vyuzila-jsem-obycejne-postovne/',
        'cheat-buyer-nogoods-registered-shipment': '/faq/zbozi-mi-neprislo-vyuzila-jsem-doporucene-postovne/',
        'cheat-buyer-seller-not-communicating': '/faq/zaplatila-jsem-zbozi-prodejce-prestal-komunikovat/',
        'cheat-buyer-goods-not-as-described': '/faq/zbozi-neodpovida-popisu-nebo-je-poskozene/',
        'cheat-buyer-not-all-goods': '/faq/neprislo-mi-vsechno-zaplacene-zbozi/',

        'cat-howto-market-cheat-seller': '/faq/faq-index-jsem-prodejce-v-bazaru/',
        'cheat-seller-nogoods': '/faq/kupujici-tvrdi-ze-ji-zaplacene-zbozi-neprislo/',
        'cheat-seller-goods-not-paid': '/faq/zbozi-jsem-odeslala-ale-kupujici-za-nej-nezaplatila/',
        'cheat-seller-cash-on-delivery-not-paid': '/faq/kupujici-neprebrala-zbozi-na-dobirku/',
        'cheat-seller-goods-not-as-described': '/faq/kupujici-tvrdi-ze-zbozi-neodpovida-popisu-v-inzeratu/',

        'cat-howto-market-cheat-elsewhere': '/faq/faq-index-obchod-mimo-bazaru/',
        'cheat-group': '/faq/obchod-ve-skupine-neprobehl-v-poradku/',
        'cheat-ip': '/faq/komunikovali-jsme-interni-postou-emailem-telefonicky-a-obchod-neprobehl-v-poradku/',

        'cat-howto-market-cheat-legal': '/faq/faq-index-pravni-pomoc-pro-poskozene/',
        'cheat-legal-overview': '/faq/rozhodla-jsem-se-ze-podam-oznameni-na-policii-jak-postupovat/',
        'cheat-legal-before': '/faq/co-vsechno-mohu-udelat-sama-jeste-pred-nahlasenim-na-policii/',
        'cheat-legal-when': '/faq/v-jakem-pripade-mam-podat-oznameni-na-policii/',
        'cheat-legal-file': '/faq/jak-mam-podat-oznameni-na-policii/',
        'cheat-legal-prepare': '/faq/jake-doklady-mam-vzit-s-sebou-na-policii/',
        'cheat-legal-next': '/faq/jak-zjistim-co-se-stalo-s-mym-oznamenim/',
        'cheat-legal-joinus': '/faq/je-nas-vice-poskozenych/',
        'cheat-legal-moneyback': '/faq/dostanu-sve-penize-zpet/',

        'paid-choose-plus-pro': '/faq/co-jsou-baliky-plus-a-pro-ktery-si-koupit/',
        'howto-pay-plus-or-pro': '/faq/jak-zaplatim-za-balik-plus-nebo-pro/',
        'paid-plus-pro-not-active': '/faq/zaplatila-jsem-za-balik-plus-nebo-pro-proc-jej-nemam-aktivni/',
        'paid-invoice-issue': '/faq/vystavite-mi-fakturu/',
        'info-paid-my-invoices': '/faq/kde-najdu-svoje-faktury/',
        'paid-change-invoicing-details': '/faq/chci-zadat-nebo-zmenit-sve-fakturacni-udaje/',
        'paid-invoice-problem': '/faq/mam-problem-s-fakturou-co-mam-delat/',
        'paid-regular-info': '/faq/co-v-ceniku-znamena-opakovana-platba/',
        'paid-card-error-first': '/faq/zadavam-platbu-kartou-ale-neuspesne-co-mam-delat/',
        'paid-card-sms-cancel': '/faq/jak-zrusim-automaticke-prodluzovani-predplatneho-z-karty/',
        'paid-card-new': '/faq/stare-platebni-karte-skoncila-platnost-jak-zadam-platbu-z-nove/',
        'paid-card-error-regular': '/faq/mam-nastavene-automaticke-prodluzovani-predplatneho-z-karty-prislo-mi-upozorneni-ze-platba-neprobehla-co-mam-delat/',
        'howto-terminate-plus-pro': '/faq/chci-ukoncit-predplatne-plus-nebo-pro-co-mam-udelat/',
        'share-reviews': '/faq/jak-sdilet-hodnoceni-z-bazaru-na-sve-webove-strance/',
        'change-plus-to-pro': '/faq/chci-prejit-z-baliku-plus-na-pro/',
        'gdpr-commercial': '/faq/mam-firmu-jake-jsou-pri-prodeji-moje-povinnosti-ohledne-gdpr/',
        'pluspro-msg': '/faq/mam-jinou-otazku-ohledne-placeneho-baliku-plus-nebo-pro/',

        'cat-technical-support': '/faq/faq/#h-mam-technicke-potize',
        'technical-problem-general': '/faq/modry-konik-nefunguje-tak-jak-by-mel-co-mam-delat/',
        'technical-problem-process': '/faq/co-mohu-ocekavat-kdyz-nahlasim-problem/',
        'howto-screenshot': '/faq/jak-udelam-foto-obrazovky-screenshot/',
        'howto-browser-update': '/faq/jak-aktualizovat-internetovy-prohlizec/',
        'technical-problem-app': '/faq/mam-problem-s-aplikaci-modry-konik-na-mobilu/',
        'howto-clear-cache': '/faq/jak-vycistim-mezipamet-cache-prohlizece/',

        'cat-life-situation': '/faq/faq/#h-resim-narocnou-zivotni-situaci',

        'cat-life-situation-me': '/faq/faq-index-potrebuji-pomoc-v-nouzi/',
        'life-lawyer': '/faq/rozvadim-se-nebo-potrebuji-pravni-poradnu-jsem-samozivitelka-a-mam-problem-s-financemi/',
        'life-finance': '/faq/jsem-ve-financni-tisni-hmotne-nouzi-mam-dluhy/',
        'life-domestic-violence': '/faq/jsem-obeti-domaciho-nasili-nebo-znasilneni/',
        'life-child-illness': '/faq/onemocnelo-mi-dite-a-nemohu-si-dovolit-platit-lecbu-ci-pomucky/',
        'life-new-work': '/faq/hledam-novou-praci/',
        'had-unplanned-pregnancy': '/faq/neplanovane-som-otehotnela/',

        'cat-life-situation-others': '/faq/faq-index-chci-pomoci-ostatnim/',
        'life-giveaway-toys': '/faq/venuji-detske-obleceni-hracky-nebo-jine-veci/',
        'life-giveaway-finance': '/faq/chci-financne-vypomoct/',
        'life-giveaway-education': '/faq/chci-poskytnout-odborne-rady/',
        'cat-life-situation-organization': '/faq/jsme-organizace-ktera-chce-pomahat-ostatnim/',

        'cat-offers': '/faq/faq/#h-navrh-na-spolupraci-nabidka-reklama',
        'offer-lowbudget-promo': '/faq/jsme-mala-firma-a-radi-bychom-u-vas-propagovali-nasi-nabidku-zn-nejradeji-zdarma/',
        'offer-3rdsector': '/faq/jsme-organizace-tretiho-sektoru-a-radi-bychom-vas-pozadali-o-podporu-spravne-veci/',
        'offer-press': '/faq/jsem-novinar-researcher-a-rad-bych-nahlednul-do-modreho-konika/',
        'offer-client': '/faq/jsme-vetsi-klient-agentura-a-jeste-nejsme-v-kontaktu/',
        'offer-other': '/faq/chteli-bychom-podporit-nas-projekt-akci-medialni-partnerstvi-nabidnout-nase-sluzby/',

        'cat-message-mk': '/faq/faq/#h-mam-vzkaz-pro-modreho-konika',
        'message-mk': '/faq/tady-muzes-zanechat-vzkaz/',

        'cat-rules': '/faq/faq/#h-podminky-pouzivani-a-pravidla',
        'privacy': '/faq/mam-otazku-ohledne-ochrany-mych-osobnich-udaju/',
        'disagree-rules': '/faq/co-kdyz-nesouhlasim-s-pravidly-modreho-konika/',
    },
}[ACTIVE_SERVER_ID];
